/**
 * Является ли страница авторским блогом
 */
export const isAuthorBlog = (pathname: string) => {
  return pathname === '/moi-blog/';
};
